/**
 * RC 1.47.5 Phase 3 — feature flag for the canonical-fit UI rewrite.
 *
 * Default: ON. Operator-first staged rollout per Q4 sign-off.
 *
 * Override mechanisms (in order of precedence):
 *   1. URL param        ?rc_1_47_5=off   — flips for the current
 *                                          session (persists in
 *                                          localStorage for 24h).
 *   2. localStorage key rc_1_47_5_ui     — set by 1 above.
 *   3. Build-time env   REACT_APP_RC_1_47_5_CANONICAL_FIT_UI=false
 *                                        — operator hard-disable.
 *   4. Otherwise        ON.
 *
 * Once Phase 3 has soaked for ≥7 days, the flag and the legacy code
 * paths it gates can be removed in a sunset slice.
 */

const LS_KEY = 'rc_1_47_5_ui';
const TTL_MS = 24 * 60 * 60 * 1000;

function readQueryParam() {
  if (typeof window === 'undefined') return null;
  try {
    const sp = new URLSearchParams(window.location.search);
    const v = sp.get('rc_1_47_5');
    if (v === 'off' || v === 'on') return v;
  } catch { /* noop */ }
  return null;
}

function readStorage() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (Date.now() - (parsed.set_at || 0) > TTL_MS) return null;
    return parsed.value === 'off' ? 'off' : 'on';
  } catch { return null; }
}

function writeStorage(value) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      LS_KEY,
      JSON.stringify({ value, set_at: Date.now() }),
    );
  } catch { /* noop */ }
}

export function isCanonicalFitUiEnabled() {
  // Build-time hard disable still trumps everything.
  if (process.env.REACT_APP_RC_1_47_5_CANONICAL_FIT_UI === 'false') {
    return false;
  }
  // Query-param override pins to localStorage for the session.
  const q = readQueryParam();
  if (q !== null) {
    writeStorage(q);
    return q === 'on';
  }
  const s = readStorage();
  if (s !== null) return s === 'on';
  return true;
}
